import React from 'react'
import { Checkbox, Col, Row } from 'antd'

class ArtStyleCheckbox extends React.Component {
  render() {
    const { onChange, value } = this.props
    return (
      <Checkbox.Group onChange={onChange} value={value} style={{marginLeft: 16}}>
        <Row>
          <Col span={8}>
            <Checkbox value='fine-art'>Fine Art</Checkbox>
          </Col>
          <Col span={8}>
            <Checkbox value='abstract'>Abstract</Checkbox>
          </Col>
          <Col span={8}>
            <Checkbox value='modern'>Modern</Checkbox>
          </Col>
          <Col span={8}>
            <Checkbox value='street-art'>Street Art</Checkbox>
          </Col>
          <Col span={8}>
            <Checkbox value='pop'>Pop Art</Checkbox>
          </Col>
          <Col span={8}>
            <Checkbox value='others'>Others</Checkbox>
          </Col>
        </Row>
      </Checkbox.Group>
    )
  }
}

export default ArtStyleCheckbox
